/* src/app/shared/components/ngx-responsive-table/components/table-control-panel/table-control-panel.component.scss */
.table-control-panel {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
:host {
  display: block;
  width: 100%;
}
/*# sourceMappingURL=table-control-panel.component.css.map */
